export const LEARN_ROLES = ['you', 'p2', 'p3', 'p4'];
/** Seat order: Player 2 sits first, so deals round 1. */
export const LEARN_SEATS = ['p2', 'you', 'p3', 'p4'];
export const LEARN_TURNS = [
    { rollKeep: [], end: [0, 1] },
    {
        rollKeep: [0, 1],
        attack: { natural: [0, 1, 2], keep: [0, 1, 2, 3], mods: [{ index: 3, value: 4 }], targets: ['p2', 'p3'] },
    },
];
/**
 * Every roll of the round, per player, in order (war rolls first). Bots' rolls kill nothing on
 * the table (no pair of 3s, no three or four of a kind, no Ka'Dice); they never attack anyway.
 */
export const LEARN_DICE = {
    you: [[4], [5, 6], [4, 4, 2, 6, 1], [4, 3, 6]],
    p2: [[4], [3, 2], [2, 6, 1, 5, 6], [4, 4, 1, 6, 2], [5, 6, 2, 2, 1]],
    p3: [
        [1, 4, 6, 6, 2],
        [6, 5, 5, 1, 2],
        [2, 2, 6, 4, 1],
    ],
    p4: [
        [5, 1, 2, 2, 6],
        [6, 1, 4, 4, 2],
        [1, 6, 6, 5, 2],
        [2, 6, 1, 6, 4],
    ],
};
/** Cards each player is dealt. */
export const LEARN_HAND_SIZE = 3;
/**
 * Each player's hand, the first card dealt first: you and Player 2 the Knight of 3's (Player 2's
 * next card the 3 of a Kind), Player 3 the 4 of a Kind, Player 4 the Ka'Dice card; the rest
 * filled with other cards. Null if the catalog lacks one of them.
 */
export function learnHands(cards) {
    const all = [...cards];
    const knight = all.find((c) => c.power === 'w3' && c.killer === 'p3');
    const three = all.find((c) => c.killer === 'xxx');
    const four = all.find((c) => c.killer === 'xxxx');
    const kadice = all.find((c) => c.killer === 'kadice');
    if (!knight || !three || !four || !kadice)
        return null;
    const cast = new Set([knight.id, three.id, four.id, kadice.id]);
    const spare = all.filter((c) => !cast.has(c.id)).map((c) => c.id);
    const fill = (first) => [...first, ...spare].slice(0, LEARN_HAND_SIZE);
    return {
        you: fill([knight.id]),
        p2: fill([knight.id, three.id]),
        p3: fill([four.id]),
        p4: fill([kadice.id]),
    };
}
//# sourceMappingURL=learn.js.map